<div
  class="header"
  *ngIf="
    globalService.footer.methodsShipment?.length
  "
>
  <p>Método de envío</p>
</div>
<div class="content">
  <img
    class="logo_entity"
    [src]="shipment.url"
    [id]="shipment.id"
    [alt]="shipment.id"
    *ngFor="let shipment of globalService.footer.methodsShipment"
  />
</div>
